/**
 * Format the duration between two dates as a short human-readable string,
 * e.g. "2d 3h", "5h 12m", "47m", "12s". Returns "Expired" if end is in the past.
 */
export const formatDurationBetween = (start, end) => {
  if (!start || !end) return "N/A";
  const ms = new Date(end).getTime() - new Date(start).getTime();
  if (ms <= 0) return "Expired";

  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m`;
  return `${totalSeconds}s`;
};

/**
 * Time remaining until a target date. Returns a label like "2h 15m"
 * or "Expired" if the date has passed.
 */
export const formatTimeRemaining = (target) => {
  if (!target) return "N/A";
  return formatDurationBetween(new Date(), target);
};
